<template>
    <div class="popup" :class="{ active: popupShow }">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>14세 미만 보호자 동의</h2>
                    <button type="button" class="popup__close" @click="popupBtn"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <h3 class="mt-none mb-none">14세 미만 소아/청소년 인증 안내</h3>
                    <p>
                        법정대리인 동의 : 정보통신부고시제2002-3호 <br class="mo-none">
                        개인정보보호지침에 의거하여 만14세미만 아동(이하 "아동")의 개인정보 수집 시 <br class="mo-none">
                        법정대리인(이하"대리인")의 동의를 얻어야 합니다. <br class="mo-none">
                        *진료결과 및 증명서 발급 서비스 이용 시, 회원 가입 시의 법정 대리인 인증이 필요합니다.
                    </p>

                    <div class="botton-wrap">
                        <button type="button" class="sub-button c-main" @click="popupBtn">취소</button>
                        <button type="button" class="main-button c-main" @click="openCert">본인인증하기</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                popupShow: false
            }
        },
        components: {
        },
        mounted() {
        },
        methods: {
            popupBtn() {
                this.popupShow = !this.popupShow
                if(!this.popupShow) this.$emit('initBirth', '')
            },
            openCert(){
                this.popupShow = false
                this.$emit('popupCertShow')
            }
        },
    }
</script>